module.exports = __webpack_public_path__ + "static/8-da89310d82015d978469ce6f1473067b.jpg";